import {
  ButtonComponent,
  VxlButtonStyle,
  VxlButtonVerticalLayout,
} from '@varo/graphql-schema-types';
import { ButtonProps } from 'shared/components/vxl/Button/Button';
import { UnknownGQLType } from 'shared/legacySDUIAdapters/genericRouteAction';
import { VXLComponentId, VXLNode } from 'shared/renderer/types';
import { Maybe } from 'shared/utils/types';

export interface ButtonComponentDependencies {
  navigateForAction: (action: Maybe<UnknownGQLType>) => void;
}

const sizeForButton = (
  verticalLayout: VxlButtonVerticalLayout,
): ButtonProps['size'] => {
  switch (verticalLayout) {
    case VxlButtonVerticalLayout.Small:
      return 'SMALL';
    case VxlButtonVerticalLayout.Large:
      return 'LARGE';
    default:
      return 'LARGE';
  }
};

const typeForButton = (style: VxlButtonStyle): ButtonProps['type'] => {
  switch (style) {
    case VxlButtonStyle.Primary:
      return 'PRIMARY';
    case VxlButtonStyle.Secondary:
      return 'SECONDARY';
    case VxlButtonStyle.Text:
      return 'TEXT';
    default:
      return 'PRIMARY';
  }
};

const buttonComponent = (
  component: ButtonComponent,
  { navigateForAction }: ButtonComponentDependencies,
): VXLNode => {
  const { id, button, onClick } = component;
  const { copy: styledCopy, style, verticalLayout, onDarkBackground } = button;
  const { copy } = styledCopy;

  let onPress: Maybe<() => void> = null;
  if (
    onClick &&
    '__typename' in onClick &&
    typeof onClick.__typename === 'string'
  ) {
    onPress = () => navigateForAction(onClick);
  }

  return {
    id: id,
    name: VXLComponentId.BUTTON,
    props: {
      label: copy,
      size: sizeForButton(verticalLayout),
      type: typeForButton(style),
      width: 'FULL',
      onDark: onDarkBackground,
      onPress,
    } satisfies ButtonProps,
  };
};

export default buttonComponent;
